/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AppRouteImport } from './routes/_app'
import { Route as DeviceRouteImport } from './routes/device'
import { Route as LinkRouteImport } from './routes/link'
import { Route as AppIndexRouteImport } from './routes/_app/index'
import { Route as AppSystemsRouteImport } from './routes/_app/systems'
import { Route as AppTabletsRouteImport } from './routes/_app/tablets'
import { Route as AuthLaunchRouteImport } from './routes/auth/launch'
import { Route as AppSettingsOrganisationRouteImport } from './routes/_app/settings/organisation'
import { Route as AppSettingsUsersRouteImport } from './routes/_app/settings/users'
import { Route as AppSettingsGroupsIndexRouteImport } from './routes/_app/settings/groups/index'
import { Route as AppSettingsGroupsIdServicesRouteImport } from './routes/_app/settings/groups/$id.services'

const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const DeviceRoute = DeviceRouteImport.update({
  id: '/device',
  path: '/device',
  getParentRoute: () => rootRouteImport,
} as any)
const LinkRoute = LinkRouteImport.update({
  id: '/link',
  path: '/link',
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)
const AppSystemsRoute = AppSystemsRouteImport.update({
  id: '/systems',
  path: '/systems',
  getParentRoute: () => AppRoute,
} as any)
const AppTabletsRoute = AppTabletsRouteImport.update({
  id: '/tablets',
  path: '/tablets',
  getParentRoute: () => AppRoute,
} as any)
const AuthLaunchRoute = AuthLaunchRouteImport.update({
  id: '/auth/launch',
  path: '/auth/launch',
  getParentRoute: () => rootRouteImport,
} as any)
const AppSettingsOrganisationRoute = AppSettingsOrganisationRouteImport.update({
  id: '/settings/organisation',
  path: '/settings/organisation',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsUsersRoute = AppSettingsUsersRouteImport.update({
  id: '/settings/users',
  path: '/settings/users',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIndexRoute = AppSettingsGroupsIndexRouteImport.update({
  id: '/settings/groups/',
  path: '/settings/groups/',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsGroupsIdServicesRoute =
  AppSettingsGroupsIdServicesRouteImport.update({
    id: '/settings/groups/$id/services',
    path: '/settings/groups/$id/services',
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AppIndexRoute
  '/device': typeof DeviceRoute
  '/link': typeof LinkRoute
  '/systems': typeof AppSystemsRoute
  '/tablets': typeof AppTabletsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/settings/organisation': typeof AppSettingsOrganisationRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesByTo {
  '/device': typeof DeviceRoute
  '/link': typeof LinkRoute
  '/systems': typeof AppSystemsRoute
  '/tablets': typeof AppTabletsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/': typeof AppIndexRoute
  '/settings/organisation': typeof AppSettingsOrganisationRoute
  '/settings/users': typeof AppSettingsUsersRoute
  '/settings/groups': typeof AppSettingsGroupsIndexRoute
  '/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_app': typeof AppRouteWithChildren
  '/device': typeof DeviceRoute
  '/link': typeof LinkRoute
  '/_app/systems': typeof AppSystemsRoute
  '/_app/tablets': typeof AppTabletsRoute
  '/auth/launch': typeof AuthLaunchRoute
  '/_app/': typeof AppIndexRoute
  '/_app/settings/organisation': typeof AppSettingsOrganisationRoute
  '/_app/settings/users': typeof AppSettingsUsersRoute
  '/_app/settings/groups/': typeof AppSettingsGroupsIndexRoute
  '/_app/settings/groups/$id/services': typeof AppSettingsGroupsIdServicesRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/device'
    | '/link'
    | '/systems'
    | '/tablets'
    | '/auth/launch'
    | '/settings/organisation'
    | '/settings/users'
    | '/settings/groups/'
    | '/settings/groups/$id/services'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/device'
    | '/link'
    | '/systems'
    | '/tablets'
    | '/auth/launch'
    | '/'
    | '/settings/organisation'
    | '/settings/users'
    | '/settings/groups'
    | '/settings/groups/$id/services'
  id:
    | '__root__'
    | '/_app'
    | '/device'
    | '/link'
    | '/_app/systems'
    | '/_app/tablets'
    | '/auth/launch'
    | '/_app/'
    | '/_app/settings/organisation'
    | '/_app/settings/users'
    | '/_app/settings/groups/'
    | '/_app/settings/groups/$id/services'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  DeviceRoute: typeof DeviceRoute
  LinkRoute: typeof LinkRoute
  AuthLaunchRoute: typeof AuthLaunchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/device': {
      id: '/device'
      path: '/device'
      fullPath: '/device'
      preLoaderRoute: typeof DeviceRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/link': {
      id: '/link'
      path: '/link'
      fullPath: '/link'
      preLoaderRoute: typeof LinkRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/systems': {
      id: '/_app/systems'
      path: '/systems'
      fullPath: '/systems'
      preLoaderRoute: typeof AppSystemsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tablets': {
      id: '/_app/tablets'
      path: '/tablets'
      fullPath: '/tablets'
      preLoaderRoute: typeof AppTabletsRouteImport
      parentRoute: typeof AppRoute
    }
    '/auth/launch': {
      id: '/auth/launch'
      path: '/auth/launch'
      fullPath: '/auth/launch'
      preLoaderRoute: typeof AuthLaunchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app/settings/organisation': {
      id: '/_app/settings/organisation'
      path: '/settings/organisation'
      fullPath: '/settings/organisation'
      preLoaderRoute: typeof AppSettingsOrganisationRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/users': {
      id: '/_app/settings/users'
      path: '/settings/users'
      fullPath: '/settings/users'
      preLoaderRoute: typeof AppSettingsUsersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/': {
      id: '/_app/settings/groups/'
      path: '/settings/groups'
      fullPath: '/settings/groups/'
      preLoaderRoute: typeof AppSettingsGroupsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/groups/$id/services': {
      id: '/_app/settings/groups/$id/services'
      path: '/settings/groups/$id/services'
      fullPath: '/settings/groups/$id/services'
      preLoaderRoute: typeof AppSettingsGroupsIdServicesRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppSystemsRoute: typeof AppSystemsRoute
  AppTabletsRoute: typeof AppTabletsRoute
  AppIndexRoute: typeof AppIndexRoute
  AppSettingsOrganisationRoute: typeof AppSettingsOrganisationRoute
  AppSettingsUsersRoute: typeof AppSettingsUsersRoute
  AppSettingsGroupsIndexRoute: typeof AppSettingsGroupsIndexRoute
  AppSettingsGroupsIdServicesRoute: typeof AppSettingsGroupsIdServicesRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppSystemsRoute: AppSystemsRoute,
  AppTabletsRoute: AppTabletsRoute,
  AppIndexRoute: AppIndexRoute,
  AppSettingsOrganisationRoute: AppSettingsOrganisationRoute,
  AppSettingsUsersRoute: AppSettingsUsersRoute,
  AppSettingsGroupsIndexRoute: AppSettingsGroupsIndexRoute,
  AppSettingsGroupsIdServicesRoute: AppSettingsGroupsIdServicesRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  DeviceRoute: DeviceRoute,
  LinkRoute: LinkRoute,
  AuthLaunchRoute: AuthLaunchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
